import { action, extendObservable } from 'mobx'

export default class Metric {
  constructor (data = {}) {
    extendObservable(this, {
      loading: false,
      error: null,
      id: null,
      projectId: null,
      clientId: null,
      averageRating: null,
      rating1: null,
      comment1: null,
      rating2: null,
      comment2: null,
      rating3: null,
      comment3: null,
      rating4: null,
      comment4: null,
      dateSent: null,
      dateSubmitted: null,
      ...data
    })
  }

  set = action(({ data = {}, error = null, loading = false }) => {
    this.loading = loading
    this.error = error
    this.id = data.id
    this.projectId = data.projectId
    this.clientId = data.clientId
    this.averageRating = data.averageRating
    this.rating1 = data.rating1
    this.comment1 = data.comment1
    this.rating2 = data.rating2
    this.comment2 = data.comment2
    this.rating3 = data.rating3
    this.comment3 = data.comment3
    this.rating4 = data.rating4
    this.comment4 = data.comment4
    this.dateSent = data.dateSent
    this.dateSubmitted = data.dateSubmitted
  })
}
